import { render, staticRenderFns } from "./Pieces.vue?vue&type=template&id=3d5d365d&scoped=true"
import script from "./Pieces.vue?vue&type=script&lang=js"
export * from "./Pieces.vue?vue&type=script&lang=js"
import style0 from "./Pieces.vue?vue&type=style&index=0&id=3d5d365d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5d365d",
  null
  
)

export default component.exports